import React from 'react';

import {assetsBaseUrl} from "../../../services/calculationsApi";
import {FormattedMessage} from "react-intl";


function NextButton({isFormValid, formState, loading}) {
    return (
    <div className={`ct-step__next-wrapper`}>
      <div className={`ct-step__next-button-wrapper`}>
      {formState.isValid &&
        <div className={`ct-step__next-button-label`}>
          <FormattedMessage id="stepParts.nexButton.label" defaultMessage="Ga verder"/>
        </div>
      }
      <button
        className={`ct-step__next-button ${
          isFormValid ? "ct-step__next-button-active" : null
          }`}
          disabled={!formState.isValid}
          type="submit"
          >
        {loading ? (
        <img
        src={`${assetsBaseUrl}/assets/svg/loading-circle.svg`}
        alt=""
        />
        ) : (
        <img
        src={`${assetsBaseUrl}/assets/svg/arrow-down.svg`}
        alt=""
        />
        )}

            {formState.isValid}
      </button>
      </div>
    </div>
    );
}

export default NextButton;
